export default __webpack_public_path__ + "static/media/Scope-13.22ea83d8.png";